"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input(props) {
        var _this = _super.call(this, props) || this;
        _this.styles = {
            field: {
                default: "font-base max-w-full transition-fast",
                element: "block rounded relative w-full h-full px-1-6 h-4-8 text-base text-inherit border transition-fast bg-transparent outline-none focus:outline-none focus:shadow-popup",
                label: "block text-xs uppercase font-semibold text-navy-dark text-left transition-fast pointer-events-none mb-0-6",
                positive: {
                    default: "",
                    element: "text-navy-dark bg-transparent border-blue-grey focus:border-navy"
                },
                negative: {
                    default: "",
                    element: "text-arctic bg-transparent border-arctic-smoke"
                }
            },
            search: {
                default: "font-base max-w-full transition-fast h-6",
                element: "block relative w-full h-full px-0 font-serif text-lg text-inherit border-b transition-fast bg-transparent outline-none focus:outline-none focus:shadow-none",
                label: "",
                positive: {
                    default: "",
                    element: "text-midnight bg-transparent border-fleece-dark focus:border-midnight",
                    label: "text-charcoal-light"
                },
                negative: {
                    default: "",
                    element: "text-arctic bg-transparent border-fleece-dark focus:border-arctic",
                    label: "text-grey-mid"
                }
            },
            textarea: {
                default: "font-sans font-base max-w-full transition-fast",
                element: "appearance-none rounded-none block relative w-full px-1-6 h-11 font-sans text-base text-inherit resize-none border transition-fast bg-transparent outline-none focus:outline-none focus:shadow-none",
                label: {
                    default: "block absolute pin-t pin-x px-1-6 text-left transition-fast pointer-events-none",
                    resting: "text-base mt-1-6",
                    active: "text-xs mt-1"
                },
                positive: {
                    default: "",
                    element: "text-midnight bg-transparent border-fleece-dark focus:border-navy",
                    label: "text-charcoal-light"
                },
                negative: {
                    default: "",
                    element: "text-arctic bg-transparent border-arctic-smoke",
                    label: "text-mist"
                }
            }
        };
        _this.state = {
            focussed: false,
            value: _this.props.value ? _this.props.value : ""
        };
        return _this;
    }
    Input.prototype.handleChange = function () {
        this.setState({
            value: event.target.value
        });
        this.props.onChange ? this.props.onChange(event) : null;
    };
    Input.prototype.render = function () {
        var _this = this;
        var _a = this.props, autoCapitalize = _a.autoCapitalize, autoCorrect = _a.autoCorrect, autoFocus = _a.autoFocus, children = _a.children, className = _a.className, disabled = _a.disabled, errors = _a.errors, grouped = _a.grouped, id = _a.id, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, placeholder = _a.placeholder, reference = _a.reference, required = _a.required, reverse = _a.reverse, style = _a.style, type = _a.type, maxLength = _a.maxLength, value = _a.value;
        var scheme = style && this.styles[style] ? this.styles[style] : this.styles[type] ? this.styles[type] : this.styles.field;
        var state = reverse ? "negative" : "positive";
        var colours = scheme[state];
        var classes = "appearance-none transition-fast " + (disabled ? "pointer-events-none opacity-20" : "cursor-pointer") + " " + scheme.default + " " + colours.default + (className ? " " + className : "");
        var element = type == "text" || type == "email" || type == "password" || type == "search" ? (React.createElement("input", { type: type, id: id ? name : null, name: name || null, className: scheme.element + " " + colours.element + " " + (this.state.value != "" && placeholder ? "" : "pt-1-3 pb-1-3") + (grouped ? " border-r-0" : ""), onBlur: onBlur ? function (event) { return onBlur(); } : null, onChange: function (event) { return _this.handleChange(); }, onFocus: onFocus ? function (event) { return onFocus(); } : null, autoComplete: "off", autofill: "off", autoCapitalize: autoCapitalize || "no", autoCorrect: autoCorrect || "no", autoFocus: autoFocus ? "autofocus" : null, required: required || null, ref: reference || null, value: this.state.value, placeholder: placeholder, maxLength: maxLength })) : type == "textarea" ? (React.createElement("textarea", { id: id ? name : null, name: name || null, className: scheme.element + " " + colours.element + " " + (grouped ? " border-r-0" : "") + " pt-1-3 rounded", onBlur: onBlur ? function (event) { return onBlur(); } : null, onChange: function (event) { return _this.handleChange(); }, onFocus: onFocus ? function (event) { return onFocus(); } : null, autoComplete: "off", autofill: "off", autoCapitalize: autoCapitalize || "no", autoCorrect: autoCorrect || "no", autoFocus: autoFocus ? "autofocus" : null, required: required || null, ref: reference || null, placeholder: placeholder }, this.state.value)) : (React.createElement("div", null));
        return (React.createElement("div", { className: "relative inline-block " + classes },
            element,
            errors ? React.createElement(Snippets.FormErrors, { errors: errors, className: "mt-1-9" }) : null));
    };
    return Input;
}(React.PureComponent));
exports.Input = Input;
